// ─────────────────────────────────────────────────────────────
// SectionTitle
// Extracted from App.js.
// ─────────────────────────────────────────────────────────────

import { C } from "../../lib/colors";

export function SectionTitle({ children, action }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: "0.1em" }}>{children}</div>
      {action}
    </div>
  );
}

